/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LocationSource = {
    Manual: 'MANUAL',
    Gps: 'GPS'
} as const;
export type LocationSource = typeof LocationSource[keyof typeof LocationSource];


export function instanceOfLocationSource(value: any): boolean {
    for (const key in LocationSource) {
        if (Object.prototype.hasOwnProperty.call(LocationSource, key)) {
            if (LocationSource[key as keyof typeof LocationSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LocationSourceFromJSON(json: any): LocationSource {
    return LocationSourceFromJSONTyped(json, false);
}

export function LocationSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationSource {
    return json as LocationSource;
}

export function LocationSourceToJSON(value?: LocationSource | null): any {
    return value as any;
}

export function LocationSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): LocationSource {
    return value as LocationSource;
}

